const RESET_BOOKING_SUBMISSION_STATE =
    '@@scheduling/RESET_BOOKING_SUBMISSION_STATE';

const UPDATING_BOOKING_STATE = '@@scheduling/UPDATING_BOOKING_STATE';
const UPDATE_LOCAL_BOOKING_STATE = '@@scheduling/UPDATE_LOCAL_BOOKING_STATE';
const UPDATE_BOOKING_STATE_SUCCESS =
    '@@scheduling/UPDATE_BOOKING_STATE_SUCCESS';
const UPDATE_BOOKING_STATE_FAILURE =
    '@@scheduling/UPDATE_BOOKING_STATE_FAILURE';

const UPDATE_IS_EXISTING_PATIENT_STATE =
    '@@scheduling/UPDATE_IS_EXISTING_PATIENT_STATE';
const UPDATE_IS_EXISTING_PATIENT_STATE_SUCCESS =
    '@@scheduling/UPDATE_IS_EXISTING_PATIENT_STATE_SUCCESS';
const UPDATE_IS_EXISTING_PATIENT_STATE_FAILURE =
    '@@scheduling/UPDATE_IS_EXISTING_PATIENT_STATE_FAILURE';

const FETCHING_BOOKING_STATE = '@@scheduling/FETCHING_BOOKING_STATE';
const FETCH_BOOKING_STATE_SUCCESS = '@@scheduling/FETCH_BOOKING_STATE_SUCCESS';
const FETCH_BOOKING_STATE_FAILURE = '@@scheduling/FETCH_BOOKING_STATE_FAILURE';

const CLEAR_BOOKING_ERROR = '@@scheduling/CLEAR_BOOKING_ERROR';
const SUBMITTING_BOOKING = '@@scheduling/SUBMITTING_BOOKING';
const SUBMIT_BOOKING_SUCCESS = '@@scheduling/SUBMIT_BOOKING_SUCCESS';
const SUBMIT_BOOKING_FAILURE = '@@scheduling/SUBMIT_BOOKING_FAILURE';

const UPDATE_BOOKING_REQUIREMENT_VALUE =
    '@@scheduling/UPDATE_BOOKING_REQUIREMENT_VALUE';

export const errorCodes = {
    ADDRESS_ERROR: 1,
    UPDATE_ERROR: 2,
    SUBMIT_ERROR: 3,
};

export const SchedulingActions = {
    RESET_BOOKING_SUBMISSION_STATE,
    UPDATING_BOOKING_STATE,
    UPDATE_LOCAL_BOOKING_STATE,
    UPDATE_BOOKING_STATE_SUCCESS,
    UPDATE_BOOKING_STATE_FAILURE,
    FETCHING_BOOKING_STATE,
    FETCH_BOOKING_STATE_SUCCESS,
    FETCH_BOOKING_STATE_FAILURE,
    CLEAR_BOOKING_ERROR,
    SUBMITTING_BOOKING,
    SUBMIT_BOOKING_SUCCESS,
    SUBMIT_BOOKING_FAILURE,
    UPDATE_BOOKING_REQUIREMENT_VALUE,
    UPDATE_IS_EXISTING_PATIENT_STATE,
    UPDATE_IS_EXISTING_PATIENT_STATE_SUCCESS,
    UPDATE_IS_EXISTING_PATIENT_STATE_FAILURE,
};
